import { LOCALE_KEY } from '@transcend-io/internationalization';

/**
 * The default locale
 */
export const DEFAULT_LOCALE = LOCALE_KEY.En;
